module.exports = __webpack_public_path__ + "img/haiti.c22b2b96.svg";